/* eslint-disable react/prop-types */
/* eslint-disable import/no-cycle */
import { makeStyles } from '@material-ui/core';
import React from 'react';
import StyledModal from './StyledModal';
import avatarManWithLaptop from '../../static/images/avatar-man-with-laptop.png';

const useStyles = makeStyles({
  root: { backgroundColor: '#FFFFFF', overflow: 'hidden', borderRadius: '16px' },
  header: {
    backgroundColor: '#c3e7ff',
    display: 'flex',
    flexDirection: 'column',
    padding: '54px 36px 54px',
    borderRadius: '0 0 16px 16px',
    marginBottom: '10px',
    textAlign: 'center',
    '@media (max-width: 480px)': {
      padding: '54px 36px 54px',
      marginBottom: '5px',
    },

    '& h3': {
      color: '#046cb3',
      fontWeight: 600,
      fontSize: '14px',
      marginBottom: '8px',
      textTransform: 'uppercase',
      fontFamily: 'Nunito, sans-serif',
      lineHeight: '1.3',
      '@media (max-width: 480px)': {
        fontSize: '12px',
        marginBottom: '6px',
      },
      '@media (max-width: 360px)': {
        fontSize: '11px',
      },
    },

    '& p': {
      margin: '0 0 5px 0',
      fontSize: '15px',
      color: '#66647a',
      fontFamily: 'Nunito, sans-serif',
      lineHeight: '1.4',
      '@media (max-width: 480px)': {
        fontSize: '13px',
        marginBottom: '3px',
      },
      '@media (max-width: 360px)': {
        fontSize: '12px',
      },
    },
  },
  main: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& img': {
      translate: '0 -40px',
      height: '260px',
      width: 'auto',
    },
  },
});

export default function NowItsUpToUsModal({ open, setOpen }) {
  const classes = useStyles();

  return (
    <StyledModal open={open} setOpen={setOpen}>
      <div className={classes.root}>
        <div className={classes.header}>
          <h3>Agora é com a gente!</h3>
          <p>
            Logo um especialista entrará em contato com você.
          </p>
        </div>
        <div className={classes.main}>
          <img src={avatarManWithLaptop} alt="" />
        </div>
      </div>
    </StyledModal>
  );
}
